/**
	jKarma MVC javascript library
	
	Copyright 2011, Jacob Mouka
	Dual licensed under the MIT or GPL Version 2 licenses.
	

Version History:

0.23
-added check for onAfterInit data element

0.22
-added onchange handler to form inputs (for simple object attributes, not yet for paths)

0.21
-adding jKarma.Array (prototype)
-generate ID for nodes being displayed without one.
-fixed IE7 bug that was removing the id from the displayed nodes
-makeClosure now returns to allow stoping any bubbling events

0.20
-namespaced the click bindings ('click.jkarma')

0.19
-can render array of primitives

0.18
-updated renderDropdown with option to use array index as value

0.17
-renderDropdown to include valueKey


0.16
-migrated to user jQuery 1.6+ prop(..) method
-added renderRadioGroup and renderCheckboxes
-added searchArray function (optional case-insensitive)
-made public method getValueForKey
-fixed log() etc functions for IE compatibility
-added tokenSeparatedString

0.15
-new keyPath attributes that can follow relationships (eg comment.user.username)
-testing with including the owning node in rendering
-variable parameter list to log, warn and error
-added jKarma.SHOW

0.14
-removed 'click' keyword for event handlers. explicit handlers is way better
-automatically hides (and shows) the passed-in node if the data is an empty array or invalid object

0.13
-for hrefs, if the new value is NOT an event, bind it to the href value attribute

0.12
-added removeFromArray

0.11
-display speed up and profiling
-changed render cloning: clone from a template
-added unique clone class name, so lists don't have to be in a parent node
-eventHandlers can be implicit (no need to pass in)
-dataBindings experimental
-a bit of refactoring for clarity

0.10
-added renderDropdown
-fixed IE bug with eventHandlers (function object does not have name)

0.9:
-added jKarma.HIDE constant

0.8:
-added recursive relationship rendering!
-made jKarma object with private methods

0.7:
-added eventHandlers parameter to jKarmaDisplay
-made passed-in node either a jQuery object or an id. 

0.6:
-added jKarmaClear, and included it in jKarmaDisplay

0.5
-does not overwrite values with '' if not in data

0.4
-form encoding will merge passed-on object
-form encoding encodes checkboxes to true/false

0.3
-added form encoding/decoding, particularly checkboxes and radiogroups
-added log utility function

TODO:
-be able to set whether to auto-hide on undefined/null values
-for form input add a onchange hanlder that pushes the data directly to the object
-add a version variable to the eventual object, and have it check for incompatibilities

*/


/**
Call with (node, data [, eventHandlers]):
	-node: is any of id, jQuery object, or html element
	-data: javascript object or array of objects
	-eventHanlders (optional): array of functions whose names match jKarma keys (ie class="$key"). 
	function will be called with parameters (associatedData, htmlElement). the function will be bound to the html element's onclick handler.
	
Instructions:
	-add html elements whose class name is $key, where key is the attribute or function (zero-parameter) of the object to be displayed
	-passed-in node should be a parent node for the html elements to fill out
	-if data is an array, node should be a wrapper node that can be cloned. It's a good idea for that wrapper
	to have another wrapper, to contain all the cloned nodes in 1 parent. eg: pass in listItem to jKarma: list > listItem > displayed values 
	

Different node types:
	-form input elements get their value set
	-img tags get their src set
	
Predefined classes:

Constants (return these values for the data bindings to do their associated action):
-jKarma.HIDE: the element will be hidden. NOTE: showing nodes that have been hidden overwrites their display property.
If they had a inline, non-default display setting (eg for <A style="display:block;">) it will be reset to default when 
showing them again. For those nodes use a style block, as opposed to inline style.
*/


(function( window, undefined ) {
	function jKarma() {
		// internal constants
		var TRIGGER_PREFIX = 'jKarmaTrigger:';

		if(jQuery.prop===undefined){
			warn('An older version of jQuery detected (prop is undefined). Setting "checked" on inputs will not work.');
		}
		
		/** Constants that, if bound to a node, it will be hidden/shown upon a call to display(). */
		this.HIDE = "jKarmaHIDE";
		this.SHOW = "jKarmaSHOW";


		// -------- Bindings stuff ----------------------------------
		/** if true jKarma will manage the links between the data and the rendered elements */
		var bindingsEnabled = false;
		
		/**
		This is a purely an internal flag that's set to true whenever update or display is called. 
		When using bindings, this flag means something has changed, so the bindings should be checked.
		This does NOT enable/disable bindings.
		*/
		var updateBindings = false;
		
		/** the bindings between data and their rendered elements */
		var bindings = new Array();


		/** used to generate IDs for nodes being displayed that do not have one. */
		var idCounter = 0;
		
		// dev variable
		var profiling = false;
		
		/** public (wrapper) method that is responsible for the rendering.*/
		this.display = function(node, data, eventHandlers) {
			updateBindings = true;
			var startDate, endDate;

			if(profiling) {
				startDate = new Date();
			}

			//NOTE this method should only do some preliminary setup and call the private doDisplay to do the actual work
			
			node = $(node);
			
			//change an array of functions into dictionary of functions
			if(eventHandlers && jQuery.isArray(eventHandlers)) {
				eventHandlers = buildFunctionDictionary(eventHandlers);
			}
			
			//The node may have been hidden in prev rendering or cloned from a hidden node. Only show 
			//previously-hidden nodes because it might mess up inline styles with 'display'.
			node.find('.' + this.HIDE).show().removeClass(this.HIDE);
			
			//it may have been previously hidden if the data was blank array or invalid object
			node.show(); 

			doDisplay(node, data, eventHandlers);
			
			if(profiling) {
				endDate = new Date();
				log('time (ms): ', endDate.getTime()-startDate.getTime());
			}
		};

		/** private method that implements rendering an object or an array. 
			@param node 			a jQuery object
			@param data 			the data to render (either an object or array)
			@param eventHandlers	dictionary of <function name><function>
			@param keyPrefix		optional string that is a prefix in the data-binding key (class name), used for traversing relationships.
		 */
		var doDisplay = function(node, data, eventHandlers, keyPrefix) {
			if(!node.attr('id')) {
				node.attr('id', 'jKarma' + idCounter++);
			}
			var cloneClass = node.attr('id') + '_CLONED';
			node.parent().find('.' + cloneClass).remove();
			node.find('._CLONED').remove();//do this to remove recursed nodes
			var isArray = jQuery.isArray(data);
			
			if(isArray && data.length>0) {
				/* Algorightm is to clone the node before rendering, render the first one, and there is more data
				render the clone (cloning first). etc. */
				//TODO could check if we NEED to clone (ie there is data left to render)
				var id = node.attr('id');	//hack for IE7: it removes the id for node
				var template = node.clone(); // IMPORTANT: clone it first, since rendering it may change (eg hide elements)
				template.removeAttr('id');
				template.addClass(cloneClass);
				renderNode(node, data[0], eventHandlers, keyPrefix);
				var newNode;
				var lastNodeAdded = node;
				for(var i=1; i<data.length; i++) {
					newNode = template.clone();
					lastNodeAdded.after(newNode); //use this instead of parent.append(...) so that parent can have more complicated structure
					renderNode(newNode, data[i], eventHandlers, keyPrefix);
					lastNodeAdded = newNode;
				}
				node.attr('id', id);	//hack for IE7: add the id back
			}
			else if(!isArray && data) {
				renderNode(node,data, eventHandlers, keyPrefix);
			}
			else {
				//if data is undefined or array length==0 clear the node and hide it
				window.jKarma.clear(node);
				node.addClass(window.jKarma.HIDE).hide();
			}
		};
		
		/** this method does the actual rendering work
			@param node 			a jQuery object
			@param data 			the data to render (either an object or array)
			@param eventHandlers	dictionary of <function name><function>
			@param keyPrefix		optional string that is a prefix in the data-binding key (class name), used for traversing relationships.
		 */
		var renderNode = function(node, data, eventHandlers, keyPrefix) {
			var nodes = node.find("[class*='$']");
			var n;
			var key;
			var newValue; //the data value being written to the node
			var callback; //used to get callback method (attributes on the node)

			/* NOTE: in some cases (all?)
				this == window
				jKarma == the class constructor
				window.jKarma == the correct object
			*/
			
			//cannot add itself if there is a prefix
			if(!keyPrefix && node.is("[class*='$']")) {
				nodes.push(node);
			}
			
			for(var i=0; i<nodes.length; i++) {
				n = $(nodes[i]);
				key = parseKey(n.attr('class'), keyPrefix);
				if(!key) {
					continue;
				}

				if(eventHandlers && eventHandlers[key]) {
					//DO NOT deprecate this, since you can bind object methods this way
					n.unbind('click.jkarma');
					n.bind('click.jkarma', makeClosure(data, eventHandlers[key]));
				}
				else if(key.indexOf(TRIGGER_PREFIX)==0) {
					//TODO should allow key to have object, eg jKarmaTrigger:myController.foo
					bindTrigger(key.substr(TRIGGER_PREFIX.length), data, node);
				}
				else if((newValue = getDataValue(data, key))!==undefined) {
					if(newValue===window.jKarma.HIDE) {
						n.hide();
						n.addClass(window.jKarma.HIDE);
					}
					else if(newValue===window.jKarma.SHOW) {
						//TODO we could hide on null as well?
						n.show();
					}
					else {
						//if the value is an array it is assumed we want to recurse and render node with the relationship key as a prefix
						if(jQuery.isArray(newValue)) {
							doDisplay(n, newValue, eventHandlers, (keyPrefix ? keyPrefix+key+'.' : key + '.'));
						}
						else {
							if(bindingsEnabled) {
								bindData(data, n, key);
							}
							if(n.is(':input')) {
								if(n.is('[type=checkbox]')) {
									//n.attr('checked', newValue=='on' || newValue===true || newValue=='true');
									n.prop('checked', newValue);
								}
								else if(n.is('[type=radio]')) {
									n.prop('checked', n.attr('value')==newValue);
								}
								else {
									n.val(newValue);
								}
								makeOnChangeHandler(n, data, key);
							}
							else if(n.is('img')) {
								n.attr('src', newValue);
							}
							else if(n.is('a')) {
								n.attr('href', newValue);
							}
							else {
								//set value for regular html element
								n.html(newValue);
							}
						}
					}
				}
				else if(window[key] && typeof window[key]=='function') {
					//would be nice to allow object references, but CSS would complain about '.' char and it can be 
					//handled by the eventHandlers map
					n.unbind('click.jkarma');
					n.bind('click.jkarma', makeClosure(data, window[key]));
				}

				//*
				if((callback = n.attr('postrender'))) {
					window[callback](data, n);
				}
				// */
			} //end for
		};

		var makeOnChangeHandler = function(node, data, key) {
			node.off('change.jkarma');
			node.on('change.jkarma', function() {
				//TODO this won't actually work for paths
				if(node.is('[type=checkbox]')) {
					data[key] = node[0].checked;
				}
				else if(node.is('[type=radio]')) {
					data[key] = node.val();
				}
				else {
					data[key] = node.val();
				}
				log('updating', data, key + ' = ' + data[key]);
			});
		};
		
		/**
		 * Returns the object's value for key.
		 * If the key points to a function, it is executed (with correct the object as caller).
		 * The key can be many relationships deep and it will follow them (eg comment.user.username).  
		 */
		var getDataValue = function(data, key) {
			var value;
			if(typeof data !== 'object') {
				value = data;
			}
			else if(key.indexOf('.')==-1) {
				value = data[key];
			}
			else {
				var keyPath = key.split('.');
				var currentKey;
				value = data;
				for(k in keyPath) {
					if(jQuery.isArray(value)) {
						//value is an array, probably meant for for recursion
						//log('found array', data, key, currentKey);
						return;
					}
					data = value;
					currentKey = keyPath[k];
					value = value[currentKey];
					if(value===null || value===undefined) {
						warn('value for key ' + key + ' (at "' +currentKey + '") is invalid, on object', data);
						return value;
					}
				}
			}

			if(typeof value=='function'){
				//value = data[key](); // <- wrong.. need to pass in currentKey
				 value = value.call(data);
			}
			return value;
		}

		var bindTrigger = function (key, data, node) {
			n.unbind('click.jkarma');
			n.bind('click.jkarma', makeClosure(data, eventHandlers[key]));

		}

		this.trigger = function(data, node) {

		}

		
		/**
		 * Public method to get an object value by key path.
		 * The key can be any number of relationships deep, eg user.address.street. 
		 */
		this.getValueForKey = function(data, key) {
			return getDataValue(data, key);
		}


		/**
		Takes a node class string (can be more than one class name) and returns the data binding key.
		If keyPrefix is passed in it will strip it from the key.
		*/
		var parseKey = function(s, keyPrefix) {
			var a = s.indexOf('$');
			var key = null;
			if(a>-1) {
				// first get everything between '$' and ' '
				var b = s.indexOf(' ', a);
				if(b>-1) {
					//parse out everything after the '$' and before the next ' '
					key = s.substr(a+1, b-a-1);
				}
				else {
					//if no spaces, just return the whole thing after the '$'
					key = s.substr(a+1);
				}
				
				//strip out the prefix
				if(keyPrefix) {
					if(key.indexOf(keyPrefix)!=0 || key.length<=keyPrefix.length) {
						key = null;
					}
					key = key.substr(keyPrefix.length);
				}
			}

			return key;
		};

		/** needed for IE compatibility */
		this.getNameOfFunction = function(o) {
			var funcNameRegex = /function (.{1,})\(/;
			var results = (funcNameRegex).exec(o.toString());
			return (results && results.length > 1) ? results[1] : "";
		};

		
		//pass in an array of functions, returns dictionary of { functionName: function }
		var buildFunctionDictionary = function (funcs) {
			var result = new Object();
			var f, name;
			for(var i=0; i<funcs.length; i++) {
				f = funcs[i];
				name = (f.name ? f.name : window.jKarma.getNameOfFunction(f));
				result[name] = funcs[i];
			}
			return result;
		};
		
		var makeClosure = function (object, func) {
			return function() {
				return func(object, this);
			}
		};
		
		/** this will clear the node of data, returning it to it's pristine state. */
		this.clear = function (node) {
			updateBindings = true;
			node = $(node);
			
			node.parent().find('.' + node.attr('id') + '_CLONED').remove();

			var nodes = node.find("[class*='$']");
			var n;
			for(var i=0; i<nodes.length; i++) {
				n = $(nodes[i]);
				if(n.is(':input')) {
					if(n.is('[type=checkbox]')) {
						n.attr('checked', false);
					}
					else if(n.is('[type=radio]')) {
						n.attr('checked', false);
					}
					else {
						n.val('');
					}
				}
				//DO NOT clear images, it doesn't work (shows as broken image). best to hide them
//				else if(n.is('img')) { 
//					n.attr('src', '');
//				}
				else if(n.is('a')) {
					n.unbind('click');
				}
				else {
					//set value for all other html element IFF their children is a text node 
					var children = n.contents();
					if(children.length==1 && children[0].nodeType==3) {
						n.html('');
					}
				}
			}
		}
		
		/**
		 * This encodes a form into a javascript object. If obj is passed in this effectively merges
		 * the form into the object. Note checkboxes are converted to true/false;
		 * @param form	a form node, id, or jQuery object
		 * @param obj	(optional) if passed in the form's data will be merged into this object.
		 * @returns obj
		 */
		this.encodeForm = function(form, obj) {
			//TODO need to handle key paths
			
			form = $(form);
			var formData = form.serializeArray();
			if(!obj) {
				obj = new Object();
			}
			for(var i=0; i<formData.length; i++) {
				obj[formData[i].name] = formData[i].value;
			}
			
			//handle checkboxes so that values are [true,false]
			var checkboxes = form.find('[type=checkbox]');
			var checkbox;
			for(var i=0; i<checkboxes.length; i++) {
				checkbox = checkboxes[i];
				/*
				jQuery (1.6+) 1.7: attr('checked') -> 'checked'/undefined, prop('checked') -> true/false
				jQuery 1.4: attr('checked') ->  true/false, prop is undefined
				read: http://api.jquery.com/prop/
				*/
				//obj[checkbox.name] = $(checkbox).attr('checked');
				obj[checkbox.name] = checkbox.checked;
				//log('checkbox', checkbox.name, obj[checkbox.name]);
			}
			return obj;
		};
		
		
		// ---- Data Bindings -----------------------------------------------------------
		/** turns data binding on or off */
		this.enableBindings = function(val) {
			bindingsEnabled = val;
		}
		/*
		
		data structure is wrong
		
		look for node, and if found update the bound data object (not key)
		*/

		/** method to bind the data to the node.
		 @param data	the data object
		 @param node	the jQuery node
		 @param key		data's attribute being bound
		 */
		var bindData = function(data, node, key) {
			//TODO figure out if we're pushing or just updating
			//bindings.push({data:data, node:node, key:key});
			
			var binding = null;
			for(var i=0; i<bindings.length; i++) {
				if(bindings[i].data === data) {
					binding = bindings[i];
					break;
				}
			}
			if(!binding) {
				binding = {data:data, nodes:new Array()};
				bindings.push(binding);
				binding.nodes.push({node:node, key:key});
			}
			else {
				var nodeFound = false;
				log('looking for', node[0]);
				for(var i=0; i<binding.nodes.length; i++) {
					log(binding.nodes[i].node[0]);
					if(binding.nodes[i].node[0]===node[0]) {
						log('yes');
						nodeFound=true;
						break;
					}
				}
				if(!nodeFound) {
					binding.nodes.push({node:node, key:key});
					log('adding binding node', node[0]);
				}
				else {
					log('not adding repeat node', node[0]);
				}
			}
			
		}
		
		/** This will update all html nodes bound to the data object with the object's new values. */
		this.update = function(data) {
			//remove stale bindings
			if(updateBindings) {
				updateBindings = false;
				var newBindings = new Array();
				for(var i=0; i<bindings.length; i++) {
					var binding = bindings[i];
					var newNodes = new Array();
					for(var j=0; j<binding.nodes.length; j++) {
						if(binding.nodes[j].parent()) {
							newNodes.push(binding.nodes[j]);
						}
						else {
							log('removing node', binding.nodes[j]);
						}
					}
					if(newNodes.length>0) {
						binding.nodes = newNodes;
						newBindings.push(binding);
					}
					else {
						log('removing binding', binding);
					}
				}
				bindings = newBindings;
			}
			//log('updating', data);
			
			
			/*
			for(var i=0; i<bindings.length; i++) {
				if(bindings[i].data===data) {
					var val = data[bindings[i].key];
					if(typeof val=='function') {
						val = data[bindings[i].key]();
					}
					bindings[i].node.html(val);
					//log('updating:', bindings[i].node[0]);
					//log('with val:', val);
					//TODO add the rest of the rendering types
				}
			}
			*/
			var binding = null;
			for(var i=0; i<bindings.length; i++) {
				if(bindings[i].data === data) {
					binding = bindings[i];
					break;
				}
			}
			if(binding) {
				for(var i=0; i<binding.nodes.length; i++) {
					var val = data[binding.nodes[i].key];
					if(typeof val=='function') {
						val = data[binding.nodes[i].key]();
					}
					binding.nodes[i].node.html(val);
					//log('updating:', bindings[i].node[0]);
					//log('with val:', val);
					//TODO add the rest of the rendering types
				}
			}
		}
		
		/**
		Searches for an object (or primitive value) in an array by comparing the objects' 'key' attributes.
		If value is an object this will get it's value by key also.
		@param value	an object or primitive value
		@param key		is a string.
		*/ 
		this.inArrayByKey = function(value, key, array) {
			value = (value instanceof Object ? value[key] : value);
			for(var i=0; i<array.length; i++) {
				if(value==array[i][key]) {
					return i;
				}
			}
			return -1;
		};
		
		this.removeFromArray = function(value, array) {
			var i = jQuery.inArray(value, array);
			if(i>-1) {
				array.splice(i, 1);
			}
		};
		
		/**
		Creates a dropdown (select) field.
		@param node		the parent select tag (id, html node, or jQuery object)
		@param values	can be simple array of value or objects
		@param key		(optional) if values are objects use this to get the attribute.
		@param valueKey	(optional) if set this is the key that is bound to the option's value
		@param useIndex	(optional) if set to true, the value attribute is set to the array index
		*/
		this.renderDropdown = function(node, values, key, valueKey, useIndex) {
			node = $(node);
			for(var i=0; i<values.length; i++) {
				node.append('<option' + (useIndex || valueKey ? ' value="' + (useIndex ? i : values[i][valueKey]) + '"' : '') + '>' + (key? values[i][key] : values[i]) + "</option>");
			}	
		};
		
		this.renderRadioGroup = function(node, values, groupName, idPrefix) {
			node = $(node);
			var val;
			var id;
			for(var i=0; i<values.length; i++) {
				val = values[i];
				id = idPrefix+i;
				node.append('<input type="radio" name="' + groupName + '" class="$' + groupName + '" value="' + i + '" id="' + (id) +'"/><label for="' + id + '">' + val + '</label><br>');
			}
		};
		
		this.renderCheckboxes = function(node, values, namePrefix, idPrefix) {
			node = $(node);
			var val;
			var id;
			var attr;
			for(var i=0; i<values.length; i++) {
				val = values[i];
				id = idPrefix + i;
				attr = namePrefix+i;
				//jKarma serializes checkboxes as { name: [true/false] } so the value is ignored
				node.append('<input type="checkbox" name="' + attr  + '" class="$' + attr + '" value="' + i + '" id="' + id + '"/><label for="' + id + '">' + val + '</label><br>');
			}
		};

		
		/**
		 * Returns a list of objects whose key(s) match the keyword.
		 * @param objects	the array of objects
		 * @param keys		either a string or array of keys into the objects
		 * @param keyword	the string to search for
		 * @param caseInsensitive pass in true to make search case-insensitive (optional. Default is false).
		 */
		this.searchArray = function(objects, keys, keyword, caseInsensitive) {
			if(!keyword || keyword.length==0) {
				return objects;
			}
			if(jQuery.isArray(keys)==false) {
				keys = [keys];
			}
			var result = [];
			if(caseInsensitive) {
				keyword = new RegExp(keyword, "i");
			}
			for(var i=0; i<objects.length; i++) {
				for(var j=0; j<keys.length; j++) {
					if(caseInsensitive) {
						if(keyword.test(objects[i][keys[j]])) {
							result.push(objects[i]);
							break;
						}
					}
					else {
						if(objects[i][keys[j]].indexOf(keyword)>-1) {
							result.push(objects[i])
							break;
						}
						
					}
				}
			}
			return result;
		}
		
		/**
		 * Gets the attributes of the objects (by keypath) and returns string separated by token (comma is default).
		 * @param objects	an array of objects
		 * @param key		the attribute to get. can be a path.
		 * @parma token		(optional) the string separator. default is comman. 
		 */
		this.tokenSeparatedString = function(objects, key, token) {
			if(!objects) {
				return '';
			}
			token = token || ',';
			var result = [];
			var val;
			for(var i=0; i<objects.length; i++) {
				val = this.getValueForKey(objects[i], key);
				if(val!==null && val!==undefined) {
					result.push(val);
				}
			}
			return result.join(token);
		};

		
		/* --- jKarma Array Object -------------------------------------------------------- */

		this.Array = function(anArray) {
			this.data = anArray || [];

			this.push = function () { 
				this.data.push.apply(this.data, arguments);
			};
			this.pop = function() { return this.data.pop(); }
			this.get = function(i) {
				return this.data[i];
			}
			this.set = function(i, value) {
				this.data[i] = value;
			}
			// this.delete ... nice to have

		}

	}; // end of jKarma class






	window.jKarma = new jKarma();
})(window);

//utility method to assign a function by key to an array of objects. */
function jKarmaAddFunction(values, key, func) {
	for(var i=0; i<values.length; i++) {
		values[i][key] = func;
	}
};

//utility method to assign a closure (func gets called for each object in values) by key to an array of objects. */
function jKarmaAddClosure(values, key, func) {
	for(var i=0; i<values.length; i++) {
		values[i][key] = func(values[i]);
	}
};

/* IE doesn't have this!!! */
function arrayJoin (val) {
	var s = val[0];
	for (var i = 1; i < val.length; i++) {
		s += ', ' + val[i];
	};
	return s;
}
/** log to console. takes variable parameters. */
function log() {
	if(window.console) {
		if(console.log.apply) {
			console.log.apply(console, arguments);
		}
		else {
			console.log(arrayJoin(arguments));
		}
	}
}

/** print warning to console. takes variable parameters. */
function warn() {
	if(window.console) {
		if(console.warn.apply) {
			console.warn.apply(console, arguments);
		}
		else {
			console.warn(arrayJoin(arguments));
		}
	}
}

/** print error to console. takes variable parameters. */
function error() {
	if(window.console) {
		if(console.error.apply) {
			console.error.apply(console, arguments);
		}
		else {
			console.error(arrayJoin(arguments));
		}
	}
}

/** centers a (jquery) node within its parent */
function center(node, dx, dy) {
	node.css({
		position:'absolute',
		top:'50%',
		left:'50%'
	})
	dx = dx || 0;
	dy = dy || 0;
	var w = -node.width()/2 + dx;
	var h = -node.height()/2 + dy;
	node.css({
		'margin-left':w+'px',
		'margin-top':h+'px'
	});
}
